import { Badge, Checkbox, Divider, Form, Input, InputNumber } from 'antd'
import PropTypes from 'prop-types'
import React from 'react'
import Delete from '~/components/deleteConfirm'
import DragDropCard from '~/components/dragDropCard'
import { editTemplateMove } from '~/states/modules/editTemplate'
import { Select } from 'antd'
const { Option } = Select

const Signer = ({
	signer,
	updateSigner,
	partyIndex,
	signerIndex,
	removeSigner,
}) => {
	const { fields } = signer

	const handleUpdateSignerInfo = (e, fieldName) => {
		switch (fieldName) {
			case 'title':
				updateSigner(
					{ ...signer, title: e.target.value },
					partyIndex,
					signerIndex
				)
				break
			case 'Nome':
				updateSigner(
					{
						...signer,
						fields: [
							{ ...signer.fields[0], variable: e.target.value },
							...signer.fields.slice(1),
						],
					},
					partyIndex,
					signerIndex
				)
				break
			case 'email':
				updateSigner(
					{
						...signer,
						fields: [
							signer.fields[0],
							{ ...signer.fields[1], variable: e.target.value },
							...signer.fields.slice(2),
						],
					},
					partyIndex,
					signerIndex
				)
				break
			case 'anchor_string':
				updateSigner(
					{
						...signer,
						anchor: [{ ...signer.anchor[0], anchor_string: e.target.value }],
					},
					partyIndex,
					signerIndex
				)
				break
			case 'anchor_x_offset':
				updateSigner(
					{ ...signer, anchor: [{ ...signer.anchor[0], anchor_x_offset: e }] },
					partyIndex,
					signerIndex
				)
				break
			case 'anchor_y_offset':
				updateSigner(
					{ ...signer, anchor: [{ ...signer.anchor[0], anchor_y_offset: e }] },
					partyIndex,
					signerIndex
				)
				break
			default:
				break
		}
	}

	return (
		<DragDropCard
			move={editTemplateMove}
			name="signers"
			key={signerIndex}
			index={signerIndex}
			listIndex={partyIndex}>
			<Form.Item
				name={`title_${partyIndex}_${signerIndex}`}
				label="Título"
				onChange={(e) => handleUpdateSignerInfo(e, 'title')}
				rules={[{ required: true, message: 'Este campo é obrigatório.' }]}
				initialValue={signer.title}>
				<Input />
			</Form.Item>
			<Form.Item
				name={`required_${partyIndex}_${signerIndex}`}
				valuePropName="checked"
				initialValue={signer.required !== false}>
				<Checkbox
					checked={signer.required !== false}
					onChange={(e) =>
						updateSigner(
							{ ...signer, required: e.target.checked },
							partyIndex,
							signerIndex
						)
					}>
					Assinatura obrigatória
				</Checkbox>
			</Form.Item>
			<Form.Item
				name={`name_${partyIndex}_${signerIndex}`}
				label="Variável do nome"
				onChange={(e) => handleUpdateSignerInfo(e, 'Nome')}
				rules={[{ required: true, message: 'Este campo é obrigatório.' }]}
				initialValue={fields.find((field) => field.value === 'Nome')?.variable}>
				<Input style={{ textTransform: 'uppercase' }} />
			</Form.Item>
			<Form.Item
				name={`email_${partyIndex}_${signerIndex}`}
				label="Variável do email"
				onChange={(e) => handleUpdateSignerInfo(e, 'email')}
				rules={[{ required: true, message: 'Este campo é obrigatório.' }]}
				initialValue={
					fields.find((field) => field.value === 'Email')?.variable
				}>
				<Input
					value={fields[1].variable}
					style={{ textTransform: 'uppercase' }}
				/>
			</Form.Item>
			<Divider />
			<Form.Item
				name={`signing_type_${partyIndex}_${signerIndex}`}
				label="Tipo de assinatura"
				initialValue={signer.signing_type || 'sign'}
				rules={[{ required: true, message: 'Selecione o tipo de assinatura' }]}>
				<Select
					value={signer.signing_type || 'sign'}
					onChange={(value) =>
						updateSigner(
							{ ...signer, signing_type: value },
							partyIndex,
							signerIndex
						)
					}>
					<Option value="sign">Assinatura</Option>
					<Option value="initial">Rúbrica</Option>
					<Option value="stamp">Selo</Option>
				</Select>
			</Form.Item>
			{(!signer.signing_type || signer.signing_type === 'sign') && (
				<>
					<Form.Item
						name={`anchor_${partyIndex}_${signerIndex}`}
						label="Variável da âncora"
						onChange={(e) => handleUpdateSignerInfo(e, 'anchor_string')}
						rules={[{ required: true, message: 'Este campo é obrigatório.' }]}
						initialValue={signer.anchor[0].anchor_string}>
						<Input style={{ textTransform: 'uppercase' }} />
					</Form.Item>
					<Form.Item
						name={`x_offset_${partyIndex}_${signerIndex}`}
						label="Deslocamento em X"
						help="Máx. ±10"
						initialValue={signer.anchor[0].anchor_x_offset}>
						<InputNumber
							formatter={(value) => `${value} pol`}
							parser={(value) => value.replace(/[pol ]{1,4}/g, '')}
							min={-10}
							max={10}
							step={0.1}
							onChange={(value) =>
								handleUpdateSignerInfo(value, 'anchor_x_offset')
							}
						/>
					</Form.Item>
					<Form.Item
						name={`y_offset_${partyIndex}_${signerIndex}`}
						label="Deslocamento em Y"
						help="Máx. ±10"
						initialValue={signer.anchor[0].anchor_y_offset}>
						<InputNumber
							formatter={(value) => `${value} pol`}
							parser={(value) => value.replace(/[pol ]{1,4}/g, '')}
							min={-10}
							max={10}
							step={0.1}
							onChange={(value) =>
								handleUpdateSignerInfo(value, 'anchor_y_offset')
							}
						/>
					</Form.Item>
				</>
			)}
			{['initial', 'stamp'].includes(signer.signing_type) && (
				<>
					<Form.Item
						name={`posX_${partyIndex}_${signerIndex}`}
						label="Posição X"
						initialValue={signer.posX ?? 600}>
						<InputNumber
							min={0}
							max={2000}
							step={1}
							value={signer.posX ?? 600}
							onChange={(value) =>
								updateSigner(
									{ ...signer, posX: value },
									partyIndex,
									signerIndex
								)
							}
						/>
					</Form.Item>
					<Form.Item
						name={`posY_${partyIndex}_${signerIndex}`}
						label="Posição Y"
						initialValue={signer.posY ?? 1000}>
						<InputNumber
							min={0}
							max={2000}
							step={1}
							value={signer.posY ?? 1000}
							onChange={(value) =>
								updateSigner(
									{ ...signer, posY: value },
									partyIndex,
									signerIndex
								)
							}
						/>
					</Form.Item>
				</>
			)}
			<div
				style={{
					display: 'flex',
					background: 'rgba(230, 236, 245, 0.5)',
					height: '40px',
					justifyContent: 'space-evenly',
					alignItems: 'center',
					margin: '25px -25px -10px -25px',
				}}>
				<Badge
					count={signerIndex + 1}
					style={{ background: 'var(--ant-primary-color)' }}
				/>
				<Divider
					type="vertical"
					style={{
						height: '20px',
						borderLeft: '1px solid #bdbdbd',
						marginTop: '2px',
					}}
				/>
				<Delete handle={removeSigner} title="Deseja excluir esse assinante?" />
			</div>
		</DragDropCard>
	)
}

Signer.propTypes = {
	signer: PropTypes.shape({
		title: PropTypes.string,
		anchor: PropTypes.arrayOf(PropTypes.object),
		fields: PropTypes.arrayOf(PropTypes.object),
		status: PropTypes.string,
		signing_date: PropTypes.string,
		signing_type: PropTypes.string,
		posX: PropTypes.number,
		posY: PropTypes.number,
		required: PropTypes.bool,
	}).isRequired,
	updateSigner: PropTypes.func.isRequired,
	removeSigner: PropTypes.func.isRequired,
	signerIndex: PropTypes.number.isRequired,
	partyIndex: PropTypes.number.isRequired,
}

export default Signer
